import React from 'react';
import { ExpenseVoucherComponent } from './ExpenseVoucher.Component';
import { httpServices } from '../../../services/httpServices';
import { CustomProgressBar } from '../../common/CustomProgressBar';
import { ErrorPage } from '../../common/error';

const filterFields = {
    'report_status': 0,
    'employee': 0,
    'name_format': 'FIRSTLAST',
    'startDate': null,
    'endDate': null
};
export class ExpenseVoucherContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasPermission: true,
            permisionError: '',
            VoucherList: [],
            SubmitAmount: 0,
            ActualAmount: 0,
            filterViewState: false,
            filterFields: filterFields,            
            employees: [],
            expenseStatus: [],
            currencySymbol :'',
            showLoader : false,
            errors:{},
        }
        this.getVoucherList = this.getVoucherList.bind(this);
        this.filterView = this.filterView.bind(this);
        this.handleFilterDateChange = this.handleFilterDateChange.bind(this);
        this.filterSubmit = this.filterSubmit.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }
    componentDidMount = () => {
        this.getVoucherList();

    };
    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (this.state.filterFields.startDate > this.state.filterFields.endDate) {
            errors["endDate"] = "End date should be greater than start date";
            formIsValid = false;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleFilterDateChange = (date, name) => {
        const f = this.state.filterFields;
        f[name] = date;
        this.setState({
            filterFields: f
        })
    };
    filterView = (open) => {
        this.setState({ filterViewState: open });
    };
    filterSubmit = () => {
        if (this.handleValidation()) {
            this.getVoucherList();
        }        
    }
    handleOnChange = (evt, value) => {
        const f = this.state.filterFields;
        const name = evt.target.name;
        f[name] = evt.target.value;
        this.setState({
            filterFields: f
        });
    }


    getVoucherList = (sdate, props) => {
        this.setState({showLoader :true});
        let apiEndpoint = 'api/expenses/expensesheets';
        let data = {
            'status': this.state.filterFields.report_status,
            'user_id': this.state.filterFields.employee,
            'name_format': this.state.filterFields.name_format,
            'start_date' : this.state.filterFields.startDate,
            'end_date' : this.state.filterFields.endDate
        }        
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                let response_data = response.data;
                if (response_data.permission === false) {
                    this.setState({
                        hasPermission : false,
                        permisionError: "You are not authorized to do this action",
                        showLoader : false
                    });
                }
                else {
                    let updatedFilterFields = { ...this.state.filterFields };
                    if (!updatedFilterFields.startDate) {
                        updatedFilterFields.startDate = response_data.start_date;
                    }
                    if (!updatedFilterFields.endDate) {
                        updatedFilterFields.endDate = response_data.end_date;
                    }
                    this.setState({
                        VoucherList: response_data.voucher_list,
                        submitAmount: response_data.submitted_amount_total,
                        actualAmount: response_data.actual_payment_total,                       
                        employees: response_data.employees,
                        expenseStatus: response_data.status,
                        filterViewState: false,
                        currencySymbol: response_data.currency_symbol,
                        showLoader : false,
                        hasPermission : true,
                        filterFields: updatedFilterFields
                    });
                }

            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }



    render() {
        return (
            <>
            <CustomProgressBar
                loaderOpen={this.state.showLoader}
            />
            {this.state.hasPermission ?
                <ExpenseVoucherComponent
                    VoucherList={this.state.VoucherList}
                    SubmitAmount={this.state.submitAmount}
                    ActualAmount={this.state.actualAmount}
                    FilterView={this.filterView}
                    FilterViewState={this.state.filterViewState}
                    FilterSubmit={this.filterSubmit}
                    FilterFields={this.state.filterFields}
                    ExpenseStatus={this.state.expenseStatus}
                    Employees={this.state.employees}
                    HandleFilterDateChange = {this.handleFilterDateChange}
                    HandleOnChange={this.handleOnChange}
                    GetVoucherList={this.getVoucherList}
                    CurrencySymbol={this.state.currencySymbol}
                    Errors ={this.state.errors}
                />:
                <ErrorPage/>
            }
            </>
        )
    }
}
